import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { type FC } from "react";
import { isEmailChannel } from "../../../channels/types";

interface SwitchChannelDialogProps {
  open: boolean;
  channelName: string | null;
  onConfirm: () => void;
  onCancel: () => void;
  willResetContent: boolean;
}

export const SwitchChannelDialog: FC<SwitchChannelDialogProps> = ({
  open,
  channelName,
  onConfirm,
  onCancel,
  willResetContent,
}) => {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>{`Switch channel to ${channelName}?`}</DialogTitle>
      <DialogContent>
        <Stack direction="column" spacing={2}>
          {willResetContent ? (
            <Alert severity="warning">
              <Typography variant="body2">
                Changing channel to {channelName} will clear all content from your Follow-Up
                {isEmailChannel(channelName)
                  ? " as newsletter formatting is not supported for this channel"
                  : ""}
                . This action cannot be undone.
              </Typography>
            </Alert>
          ) : (
            <>
              <Typography variant="body2">
                Changing channel to {channelName} will convert your message content and remove
                unsupported formatting, including column layouts, button styling, and some text
                formatting.
              </Typography>
              <Typography variant="body2">This action cannot be undone.</Typography>
            </>
          )}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "flex-end", px: 3, pb: 2 }}>
        <Button onClick={onConfirm} color="primary" data-analytics-id="follow-up-channel-switch">
          Switch channel{willResetContent && " and lose content"}
        </Button>
        <Button
          onClick={onCancel}
          color="primary"
          data-analytics-id="follow-up-channel-keep-original"
        >
          Keep original channel
        </Button>
      </DialogActions>
    </Dialog>
  );
};
